import apiClient from './client';
import {ActorLibraryResponseMessage} from '@/types/ActorLibraryResponse';

/**
 * Fetches the library list of video subjects for the current user.
 * Optional filters:
 * - titleClass: filter by class category
 * - titleLingo: filter by language
 */
export async function fetchActorLibrary(
  filters?: { titleClass?: string; titleLingo?: string }
): Promise<ActorLibraryResponseMessage> {
  const response = await apiClient.get<ActorLibraryResponseMessage>(
    '/secure/actor/library',
    { params: filters }
  );
  return response.data;
}
